/*
 * @Author: jiangfeng
 * @Date: 2022-03-09 17:52:27
 * @LastEditTime: 2024-07-29 20:05:56
 * @LastEditors: jiangfeng
 * @FilePath: /governance-driver-projects/packages/acceptor-center/src/service/index.js
 */
import { fetchGet, fetchPost } from './http';
import dialog from '@/components/ui/dialog/index';
import { Omega } from '@/utils/util';
import url from '@/service/url';

const fetchHandler = (responce, _url) => {
  return new Promise((resolve, reject) => {
    const { errno, errmsg, data } = responce;
    if (+errno === 0) {
      resolve(data);
    } else {
      if (errno === 1042 || errno === 1044) {
        dialog.alert({ desc: errmsg });
      } else if(_url.indexOf(url.submit) > -1 || _url.indexOf(url.preCheck) > -1) {
        dialog.alert({ desc: '请联系人工客服处理～' });
      } else{
        dialog.alert({ desc: '网络开小差～' });
      }
      Omega({
        eventId: 'tech_wyc_accept_center_request_fail',
        eventLabel: '接口请求失败',
        attrs: {
          errno,
          errmsg
        }
      });
      reject(errmsg);
    }
  });
};

// eslint-disable-next-line one-var
export const $$get = (url, params) => {
  Omega({
    eventId: 'tech_wyc_accept_center_request_send',
    eventLabel: '接口发起请求',
    attrs: {
      mth: 'get',
      url: url
    }
  });
  return fetchGet(url, params).then(responce => fetchHandler(responce, url));
};

// eslint-disable-next-line one-var
export const $$post = (url, params) => {
  Omega({
    eventId: 'tech_wyc_accept_center_request_send',
    eventLabel: '接口发起请求',
    attrs: {
      mth: 'post',
      url: url
    }
  });
  return fetchPost({ url, params }).then(responce => fetchHandler(responce, url));
};
